
<div>
    {{text}}<br/>
    <a *ngIf="isShowMoreButton" (click)="toggleReadMore()" href="javascript:void(0)" style="color: blue;cursor: pointer;text-decoration: underline;" >{{readMoreButtonText}}</a>
</div>
